/* tjs <- get-css-var.ts */

/* line 1 */
export function getCssVar(variableName, atElement = document.body) {
    const computedStyle = getComputedStyle(atElement);
    if (variableName.endsWith(')') && variableName.startsWith('var(')) {
        variableName = variableName.slice(4, -1);
    }
    return computedStyle.getPropertyValue(variableName).trim();
}
getCssVar.__tjs = {
  "params": {
    "variableName": {
      "type": {
        "kind": "string"
      },
      "required": true,
      "default": null
    },
    "atElement": {
      "type": {
        "kind": "any"
      },
      "required": false
    }
  },
  "returns": {
    "type": {
      "kind": "string"
    }
  },
  "unsafeReturn": true,
  "unsafe": true,
  "source": "get-css-var.ts:4"
}